/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const LabelBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
`;

export const Container = styled.div`
  display: flex;
  align-items: start;
  margin-top: 32px;
  gap: 32px;
  .inputBox:first-of-type {
    width: fit-content;
  }

  .inputBox:nth-of-type(2) {
    width: 100%;
  }
`;

export const InputBox = styled.div.attrs({
  className: 'inputBox',
})`
  display: flex;
  flex-direction: column;
`;

export const ListContainer = styled.div`
  max-height: 150px;
  overflow-y: auto;
  ::-webkit-scrollbar {
    width: 6px;
    background-color: #fff;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #cbd5e1;
    border-radius: 8px;
  }
`;
